export const AI_TEXT_GENERATION_FORM_FILEDS_TEXTAREA_MIN_ROWS = 1
